import React from 'react'

const Pagination = ({ page, total, ready }) => {
  return (
    <div className='gp-frame-footer'>
      <div className='pagination'>
        {ready ? (
          <React.Fragment>
            <font style={{ opacity: 0.35 }}>Page</font>
            <font style={{ opacity: 0.85 }}> {page} </font>
            <font style={{ opacity: 0.35 }}>out of </font>
            <font style={{ opacity: 0.85 }}>{total}</font>
          </React.Fragment>
        ) : null}
      </div>
    </div>
  )
}

export default Pagination
